
import * as Project from "./otherProjectStyles";

import { FaGithub } from "react-icons/fa"
import { useWindowWidth } from "@react-hook/window-size";


export default function OtherProjectItem({ project }){
    const windowWidth = useWindowWidth();

    
    var substringEnd = project.description.substring(50, 120).lastIndexOf(".") + 51;
    
    return (
        <>
            <Project.ItemContainer>
                <Project.ItemSnapshotContainer>
                    <Project.ItemSnapshot src={project.photoUrl} />
                </Project.ItemSnapshotContainer>

                <Project.InfoContainer>
                    <Project.FeaturedText>Feature Project</Project.FeaturedText>
                    <Project.ItemName>{project.title}</Project.ItemName>
                    <Project.Link href={project.github} target="_blank"><FaGithub /></Project.Link>
                    <Project.DescriptionContainer>
                        <Project.DescriptionText>
                        {   
                            windowWidth <= 340? project.description.substring(0,substringEnd) : project.description
                         }
                        </Project.DescriptionText>
                    </Project.DescriptionContainer>
                </Project.InfoContainer>

            </Project.ItemContainer>
        </>

    )
}